import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError} from 'rxjs';
import { DataService } from '../data.service';
import { RatesSroMaster, RatesFrtProcureEdit, RatesFrtProcure, FrtServicesMaster, StateCountry} from '../../shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class FrtRateEditService extends DataService {

  private baseURIsros = this.apiUri + '/ratetypessro/';
  private baseURIOrigDest = this.apiUri + '/statecountry/';
  private baseURIfrt = this.apiUri + '/ratesfrt/';
  private baseURIFrtServices = this.apiUri + '/frtservicesmaster/';
  private baseURIFrtTemplate = this.apiUri + '/srotemplate/frt/';

  constructor(http: HttpClient) {
    super(http);
  }

  getSros(rateTypeId: number): Observable<RatesSroMaster[]> {
    this.setUri(this.baseURIsros + rateTypeId + '/rateTypeId/');
    return  this.get().pipe(catchError(this.handleError));
  }

  getSrosByBidcycle(rateTypeId, bidCycleId, carrierId): Observable<RatesSroMaster[]> {
    this.setUri(this.apiUri + `/ratesbidcycles/getSrosForRateBidcyclesFRT/${bidCycleId}/ratesBidcyclesId/${carrierId}/carrierId/${rateTypeId}/rateTypeId`);
    return  this.get().pipe(catchError(this.handleError));
  }


  getOrigDest(statecountrytype: string): Observable<StateCountry[]> {
    this.setUri(this.baseURIOrigDest + statecountrytype + '/statecountrytype/');
    return  this.get().pipe(catchError(this.handleError));
  }

  getOrigDestBySroIds(sroIds): Observable<StateCountry[]>  {
    // http://localhost:4600/tmssserver/api/public/ratessroorigindestination/getStateCountrybyoriginid/932,957/sroMasterids
    this.setUri(this.apiUri + `/ratessroorigindestination/getStateCountrybyoriginid/${sroIds}/sroMasterids`);
    return  this.get().pipe(catchError(this.handleError));
  }

  getDestByOriginBySro(sroIds, originId) {
    this.setUri(this.apiUri + `/ratessroorigindestination/getStateCountrybyoriginid/${sroIds}/sroMasterids/${originId}/originId`);
    return  this.get().pipe(catchError(this.handleError));
  }

  getAllRatesList(carrierId: string, rateTypeId: string, sroMasterId: string,
                  originId: string, destinationId: string, ratesBidcyclesId: number,
                  statusType: string): Observable<RatesFrtProcureEdit[]> {

    this.setUri(this.baseURIfrt + carrierId + '/carrierId/' +
      ratesBidcyclesId + '/ratesBidcyclesId/' +
                                  rateTypeId + '/rateTypeId/' +
                                  sroMasterId + '/sroMasterId/' +
                                  originId + '/originId/' +
                                  destinationId + '/destinationId/' +
                                  statusType + '/statusType/');
    return  this.get().pipe(catchError(this.handleError));
  }

  getFrtServicesMaster(controlId: string, sroMasterId: string):
        Observable<FrtServicesMaster[]> {
          this.setUri(this.baseURIFrtServices + controlId + '/controlId/' +
                                          sroMasterId + '/sroMasterId/');
          return  this.get().pipe(catchError(this.handleError));
  }

  deleteRatesFrtProcure(procureIdArray: number[]): Observable<any> {
    this.setUri(this.baseURIfrt + 'deleteRatesFrt');
    return this.update(procureIdArray);
  }

  updateRatesFrtProcure(ratesHhgList: RatesFrtProcure[]): Observable<any> {
    this.setUri(this.baseURIfrt + 'updateRatesFrt');
    return this.update(ratesHhgList);
  }
  getFrtTemplateFile(rateTypeId, sroId, carrierId, ratesBidcyclesId): Observable<any> {
    const url = this.baseURIFrtTemplate + rateTypeId + '/rateType/' + sroId + '/sroMasterId/' + carrierId + '/carrierId/' + ratesBidcyclesId + '/bidCycleId';
    this.setUri(this.baseURIFrtTemplate + rateTypeId + '/rateType/' + sroId + '/sroMasterId/' + carrierId + '/carrierId/' + ratesBidcyclesId + '/bidCycleId');
    // http://localhost:8380/tmssserver/api/public/srotemplate/frt/LTL/rateType/54/sroMasterId/423/carrierId/239/controlId
    return this.get();
  }
}
